/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyDataAliases {
  CARD_0 = 'card-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_0 = 'fetch-0',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FORM_0 = 'form-0',
  LINK_CHANGE_PW = 'link-change-pw',
  LINK_CLOSE_MY_ACCOUNT = 'link-close-my-account',
  LINK_PRIVACY = 'link-privacy',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_CLOSE_MY_ACCOUNT = 'panel-close-my-account',
  PANEL_LAST_ACCESS = 'panel-last-access',
  PANEL_MY_DATA = 'panel-my-data',
  TEXT_0 = 'text-0',
  TEXT_LAST_ACCESS = 'text-last-access',
}
export { MyDataAliases };
